import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ContactCycleRequest, ContactCycleResponse, PageResponse } from '../models/contact-cycle.model';

@Injectable({
  providedIn: 'root'
})
export class ContactCycleApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/contact-cycles?businessId=&page=&size= (paginado desde v1.16)
  getCycles(businessId: number, page = 0, size = 100): Observable<ContactCycleResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<ContactCycleResponse>>(`${this.apiUrl}/contact-cycles`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/contact-cycles/{id}?businessId=
  getCycleById(id: number, businessId: number): Observable<ContactCycleResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactCycleResponse>(`${this.apiUrl}/contact-cycles/${id}`, { params });
  }

  // POST /api/contact-cycles
  createCycle(cycle: ContactCycleRequest): Observable<ContactCycleResponse> {
    return this.http.post<ContactCycleResponse>(`${this.apiUrl}/contact-cycles`, cycle);
  }

  // PUT /api/contact-cycles/{id}
  updateCycle(id: number, cycle: ContactCycleRequest): Observable<ContactCycleResponse> {
    return this.http.put<ContactCycleResponse>(`${this.apiUrl}/contact-cycles/${id}`, cycle);
  }

  // DELETE /api/contact-cycles/{id}?businessId=
  deleteCycle(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/contact-cycles/${id}`, { params });
  }

  // POST /api/contact-cycles/reorder?businessId= — body: ids en el nuevo orden (lista COMPLETA).
  // El backend asigna display_order por posición empezando en 1. Responde 204 sin body.
  reorderCycles(businessId: number, orderedIds: number[]): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<void>(`${this.apiUrl}/contact-cycles/reorder`, orderedIds, { params });
  }
}
